/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import Vuex from "vuex";

// Store functionality
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { loader } from "./modules/loader";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

// Create a new store
const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  actions,
  getters,
  mutations,
  state,
  modules: {
    loader: loader,
  },
});

export default store;
